import { __decorate } from "tslib";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
let DashboardBoardWidget = class DashboardBoardWidget extends Vue {
    get percentValue() {
        const percent = (this.board.users_boards_aggregate.aggregate.count / this.usersCount) *
            100;
        return Math.round(percent);
    }
    get percentLabel() {
        return `${this.percentValue}%`;
    }
    get progressBarStyle() {
        return { width: `${this.percentValue}%` };
    }
};
__decorate([
    Prop({ type: Object, required: true })
], DashboardBoardWidget.prototype, "board", void 0);
__decorate([
    Prop({ type: Number, required: true })
], DashboardBoardWidget.prototype, "usersCount", void 0);
DashboardBoardWidget = __decorate([
    Component({})
], DashboardBoardWidget);
export default DashboardBoardWidget;
